import {SwiperImpl as Swiper} from '@/app/js/swiper/swiper'

export function initDesktopHeaderBanners() {
  const bannerElements = document.querySelectorAll('[data-swiper="header-banner"]')

  if (!bannerElements) {
    return
  }

  for (const banner of bannerElements) {
    new Swiper(banner, {
      autoplay: {
        delay: 3000,
      },
      loop: true,
      spaceBetween: 20
    })
  }
}
